export default "__VITE_ASSET__f7b8b338__"